import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenMaterialFetchAction from './communityGardenMaterialFetch.action.json' with { type: 'json' }
import { communityGardenMaterialObject } from '../../communityGardenMaterialObject'

const communityGardenMaterialFetchDefinition = defineAction({
  ...communityGardenMaterialFetchAction,

  input: z.object({
    id: communityGardenMaterialObject.shape.id,
    includeDeleted: z.boolean().nullish(),
  }),
  output: communityGardenMaterialObject,
})

export default communityGardenMaterialFetchDefinition
